import classNames from 'classnames'

import { CARD_RADIUS_STYLES } from '@apps-common/config/styles'

export const UnitManageCardSkeleton: React.FC = () => (
  <div className={classNames('relative w-full pt-[100%] flex flex-col bg-skeleton', CARD_RADIUS_STYLES)}>
    <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center animate-pulse'>
      <div className='w-full'>
        <div className={classNames('relative w-[50%] pt-[50%] rounded-[50%] mx-auto bg-skeleton-hi')}>
          <div className={classNames('absolute top-0 left-0 w-full h-full flex items-center justify-center')} />
        </div>
        <div className={classNames('flex items-center justify-between text-[0.85em] jost grow w-full px-[1rem] mt-2 gap-[5px]')}>
          <div className='h-[20px] grow bg-skeleton-hi rounded-full' />
          <div className={classNames('w-[20px] h-[20px] rounded-[50%] flex items-center justify-center bg-skeleton-hi')} />
        </div>
      </div>
    </div>
  </div>
)
